import { twMerge } from 'tailwind-merge';
import { Card } from '@/components/ui/daisy';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import {
  OrderingCorrectionEntry,
  OrderingCorrectionStatus,
} from '@/components/question/view/typologies/ordering/useOrderingCorrection';

type OrderingResultItemProps = {
  entry: OrderingCorrectionEntry;
};

const cardClasses: Record<OrderingCorrectionStatus, string> = {
  correct: 'bg-success-content border-success text-success',
  incorrect: 'bg-error-content border-error text-error',
};

export function OrderingResultItem({ entry }: OrderingResultItemProps) {
  return (
    <Card
      className={twMerge(
        'flex flex-row items-center gap-2 border px-5 py-3 font-poppins font-600 text-lg',
        cardClasses[entry.status],
      )}
    >
      <AnswerContent answer={entry.item} />
    </Card>
  );
}
